(function () {
    var $body = $('body'),
        isMobile = false;

    var accordion = {
        $elements: $('.accordion'),
        $tabbedElements: $('.accordion-tabbed'),
        $controllers: $('.accordion__control'), //@todo: remove ambiguous DOM searches for elements that are unused and move other into init function
        $tabbedControllers: $('.accordion-tabbed__control'),
        isMobile: false,
        isStickyBody: false,
        vPort: 'screen-sm',
        $responsiveElements: $('[data-accordion-vport]'),
        accVport: [],
        $responsiveTarget: [],
        collapseTabs: false,
        collapseAccordion: true, // collapse accordion on open new accordion
        defaultCollapsed: true, // collapse accordion on pageload
        hideAllBoolean: true,
        openedAccordion: 0,
        hideDropBlock: true,

        init: function () {
            accordion.initResponsive();
            accordion.logic($('.accordion-tabbed')); // collapse all accordions on page load
            accordion.control();
            accordion.additionalControls();
        },
        additionalControls: function () {},
        control: function () {
            $body.on('click', '.accordion__control', function (e) {
                e.stopImmediatePropagation();

                // Send analytics for AI summary accordion controls
                const $this = $(this);
                if ($this.hasClass('ai-summary-accordion-control')) {
                    const doi = $this.attr('doi');
                    if (doi) {
                        const ariaExpanded = $this.attr('aria-expanded');
                        const isExpanded = ariaExpanded !== 'true';
                        const eventType = isExpanded ? 'showSummary' : 'hideSummary';
                        accordion.sendAnalyticsEvent(eventType, doi);
                    }
                }

                // This check is needed on Safari browser in order to close the dropblock if its opened
                if ($this.closest('.accordion').is('[data-inline-controls]')) {
                    accordion.handleInlineControls(e);
                    return;
                }
                if ($body.attr('data-active') === 'dropBlock' && accordion.hideDropBlock) {
                    UX.dropBlock.on.hide();
                }
                const attr = $this.is('[data-slide-target]');
                // Check if its external link or if its slide controll and mobile view port
                if ($this.hasClass('external') || (typeof attr !== typeof undefined && attr !== false && isMobile)) {
                    return; // do nothing
                } else {
                    e.preventDefault();
                    accordion.on.toggle.single($this);
                }

                $this.trigger('accordion:controlClick');
            });
            if (config.enableAccordionTypeSingle || config.enableAccordionTypeSubsection) {
                $body.on('click', '.accordion-tabbed__control', function (e) {
                    const attr = $(this).is('[data-slide-target]');
                    // Check if its external link or if its slide controll and mobile view port or prevent accordion behavior
                    if (
                        $(this).hasClass('external') ||
                        (typeof attr !== typeof undefined && attr !== false && isMobile) ||
                        accordion.preventAccordionBehavior($(this))
                    ) {
                        return; // do nothing
                    } else {
                        e.preventDefault();
                        const $this = $(this);
                        accordion.on.toggle.tabbed($this);
                    }
                });
            }

            if (config.enableAccordionExpandAll) {
                $body.on('click', '.expand-all', function (e) {
                    e.preventDefault();
                    const $this = $(this);
                    accordion.on.toggle.all($this);
                });
            }

            $(document).on(accordion.vPort + '-on', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                isMobile = true;
            });

            $(document).on(accordion.vPort + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to deactivate responsive effects
                isMobile = false;
            });
        },
        logic: function (elem) {
            if (accordion.hideAllBoolean) {
                accordion.hideAll();
            }

            accordion.$tabbedElements = elem;

            accordion.$tabbedElements.each(function () {
                var $this = $(this),
                    parentAccordion = $this.closest('.accordion');

                if (parentAccordion.parent('[data-default-collapsed]').length) {
                    accordion.defaultCollapsed = parentAccordion.parent().data('default-collapsed');
                }

                $this.find('.accordion-tabbed__tab').each(function (index) {
                    var $this = $(this);
                    if (accordion.defaultCollapsed || accordion.defaultCollapsed === 'all') {
                        if (accordion.preventAccordionBehavior($this)) {
                            return;
                        }
                        if (
                            !accordion.collapseTabsByDefault(this) &&
                            index === accordion.openedAccordion &&
                            !$this.hasClass('accordion__closed')
                        ) {
                            $this.addClass('js--open');
                            $this.find('.accordion-tabbed__control').attr('aria-expanded', 'true');
                            $this.find('.accordion-tabbed__content').show();
                            if ($this.find('.accordion-lazy').length) {
                                accordion.getAccordionContent($this.find('.accordion-lazy'));
                            }
                        } else {
                            $this.removeClass('js--open');
                            $this.find('.accordion-tabbed__control').attr('aria-expanded', 'false');
                            $this.find('.accordion-tabbed__content').hide();
                        }
                    } else {
                        $this.addClass('js--open');
                        $this.find('.accordion-tabbed__control').attr('aria-expanded', 'true');
                        $this.find('.accordion-tabbed__content').show();
                    }
                });
            });
        },
        collapseTabsByDefault: function () {
            return accordion.collapseTabs;
        },
        additionalAjaxSuccess: function ($elem) {},
        getCustomAjaxUrl: function ($elem) {},
        buildAjaxUrl: function ($elem) {
            let ajaxUrl;
            var hasCustomUrl =
                typeof $elem.attr('data-custom-url') !== 'undefined' && $elem.attr('data-custom-url') === 'true';
            if (hasCustomUrl) {
                ajaxUrl = accordion.getCustomAjaxUrl($elem);
            } else {
                const widgetId = $elem.attr('data-widgetid');
                const dropzoneId = $elem.attr('data-dropzoneid');
                const pbContext = encodeURIComponent($('meta[name=pbContext]').attr('content'));
                ajaxUrl =
                    '/pb/widgets/accordion/loadTab?pbContext=' +
                    pbContext +
                    '&widgetId=' +
                    widgetId +
                    '&dropZoneId=' +
                    dropzoneId;
            }
            return ajaxUrl;
        },
        getAccordionContent: function ($elem) {
            var ajaxUrl = accordion.buildAjaxUrl($elem);
            var $parentTab = $elem.parent();
            $.ajax({
                url: ajaxUrl,
                success: function (data) {
                    $elem.closest('.accordion-tabbed__tab').attr('data-ajaxLoaded', 'true');
                    $elem.replaceWith(data);
                    if ($parentTab.find('.accordion-tabbed').length) {
                        accordion.logic($parentTab.find('.accordion-tabbed'));
                    }
                    $parentTab.find('.accordion__spinner').remove();
                    accordion.additionalAjaxSuccess($parentTab);
                },
                error: function () {},
            });
        },
        on: {
            toggle: {
                single: function ($this) {
                    let state;
                    var $accordionContent = $this.next('.accordion__content');
                    if (typeof $this.attr('data-content-target') !== 'undefined') {
                        const contentTarget = $this.attr('data-content-target');
                        $accordionContent = $(contentTarget);
                    }
                    $accordionContent.slideToggle(200, function () {
                        if ($this.parent().hasClass('article-accordion')) {
                            $('.article-row-left').height('auto');
                            accordion.isStickyBody = state;
                        }
                    });
                    $this.toggleClass('js--open');

                    const $wrapper = $this.closest('.expandable-accordion');

                    state = !($this.attr('aria-expanded') === 'true');
                    $this.attr('aria-expanded', state);
                    const accordionExpandedSingle = $.Event('accordion:expandedSingle');
                    $(document).trigger(accordionExpandedSingle, [$this, $accordionContent]);
                    if ($wrapper.length) accordion.on.checkExpandAll($this, state, $wrapper);
                },
                tabbed: function ($this) {
                    const $parent = $this.closest('.accordion-tabbed__tab');
                    const $opened = $this.closest('.accordion-tabbed').children('.js--open');

                    const state = !($this.attr('aria-expanded') === 'true');
                    $this.attr('aria-expanded', state);
                    const $wrapper = $this.closest('.expandable-accordion');
                    if ($wrapper.length) accordion.on.checkExpandAll($this, state, $wrapper);
                    if (!$parent.hasClass('js--open')) {
                        if (accordion.collapseAccordion || accordion.extraCollapseAccordionCheck($parent)) {
                            $opened.find('.accordion-tabbed__content').slideUp(200);
                        }
                        $parent.find('.accordion-tabbed__content').slideDown(200, function () {
                            if (accordion.collapseAccordion || accordion.extraCollapseAccordionCheck($parent)) {
                                $opened.removeClass('js--open');
                            }

                            $parent.addClass('js--open');
                            if ($parent.attr('data-ajaxLoaded') !== 'true' && $parent.find('.accordion-lazy').length) {
                                accordion.getAccordionContent($parent.find('.accordion-lazy'));
                            }
                            accordion.on.expanded($this);
                            const accordionExpandedTabbed = $.Event('accordion:expandedTabbed');
                            $(document).trigger(accordionExpandedTabbed, [$this]);
                        });
                    } else {
                        $parent.find('.accordion-tabbed__content').slideUp(200, function () {
                            $this.removeClass('js--open');
                            $parent.removeClass('js--open');
                            // @fixme: work with aria-expanded is missing here, so it doesn't work correct
                        });
                    }
                },
                all: function ($this) {
                    var $wrapper = $this.closest('.expandable-accordion');
                    var state = !($this.attr('aria-expanded') === 'true');

                    $this.attr('aria-expanded', state);
                    if (state) {
                        $wrapper.find('.accordion-tabbed__tab').addClass('js--open');
                        $wrapper
                            .find('.accordion__control, .accordion-tabbed__control')
                            .addClass('js--open')
                            .attr('aria-expanded', state);
                        $wrapper.find('.accordion__content, .accordion-tabbed__content').slideDown(200);

                        $this.text('Hide All');

                        const $lazy = $wrapper.find('[data-ajaxLoaded]');
                        $lazy.each(function () {
                            if ($lazy.attr('[data-ajaxLoaded]') !== 'true' && $lazy.find('.accordion-lazy').length) {
                                accordion.getAccordionContent($lazy.find('.accordion-lazy'));
                            }
                        });
                    } else {
                        $wrapper.find('.accordion-tabbed__tab').removeClass('js--open');
                        $wrapper
                            .find('.accordion__control, .accordion-tabbed__control')
                            .removeClass('js--open')
                            .attr('aria-expanded', state);
                        $wrapper.find('.accordion__content, .accordion-tabbed__content').slideUp(200);

                        $this.text('Expand All');
                    }
                },
            },
            expanded: function ($this) {},
            checkExpandAll: function ($this, state, $wrapper) {
                let $expandElem;
                if ($wrapper.length) {
                    $expandElem = $wrapper.find('.expand-all');
                }

                if ($expandElem.length && $expandElem.attr('aria-expanded') === 'true') {
                    $expandElem.attr('aria-expanded', state);
                    if (state) $expandElem.text('Hide All');
                    else $expandElem.text('Expand All');
                }
            },
        },
        handleInlineControls: function (e) {
            var $control = $(e.currentTarget);
            var $accordion = $control.closest('.accordion[data-inline-controls]');
            var targetId = $control.attr('aria-controls');
            if ($accordion.length && targetId) {
                var $targetContent = $accordion.find('.accordion__content#' + targetId);
                var isOpen = $control.hasClass('js--open');
                if (isOpen) {
                    // If already open, close it
                    $targetContent.removeClass('js--open').attr('aria-expanded', 'false').slideUp(200);
                    $control.attr('aria-expanded', 'false').removeClass('js--open');
                } else {
                    // Hide all contents and remove open state
                    $accordion.find('.accordion__content').each(function () {
                        $(this).removeClass('js--open').attr('aria-expanded', 'false').slideUp(200);
                    });
                    // Remove open state from all controls
                    $accordion.find('.accordion__control[aria-controls]').each(function () {
                        $(this).attr('aria-expanded', 'false').removeClass('js--open');
                    });
                    // Show the target content and set open state
                    if ($targetContent.length) {
                        $targetContent.addClass('js--open').attr('aria-expanded', 'true').slideDown(200);
                        $control.attr('aria-expanded', 'true').addClass('js--open');
                    }
                }
            }
        },
        hideAll: function () {
            //Hide accordion content on load (in case of disabled JS, the accordion should be open)
            accordion.$elements.each(function () {
                var $this = $(this);
                $this.find('.accordion__control').attr('aria-expanded', 'false');
                if (!$this.find('.accordion__content').hasClass('js--open')) {
                    $this.find('.accordion__content').hide();
                } else if ($this.find('.accordion__content').hasClass('js--open')) {
                    $this.find('.accordion__control').attr('aria-expanded', 'true');
                } else {
                    $this.find('.accordion__content').removeClass('js--open');
                }
            });
        },
        initResponsive: function () {
            if (accordion.$responsiveElements.length) {
                accordion.$responsiveElements.each(function (index) {
                    accordion.$responsiveTarget[index] = $(this);
                    accordion.accVport[index] = $(this).data('accordion-vport');
                    accordion.setViewports(index);
                });
            }
        },
        extraCollapseAccordionCheck: function ($parent) {
            return accordion.collapseAccordion;
        },
        setViewports: function (index) {
            $(document).on(accordion.accVport[index] + '-on', function () {
                var target = accordion.$responsiveTarget[index];
                if (target.data('accordion-vport') === accordion.accVport[index]) {
                    target.addClass('accordion-vport--res');
                    if (target.data('accordion-option') === 'with-arrow') {
                        target.addClass('accordion-with-arrow');
                    }
                    accordion.logic(accordion.$responsiveTarget[index].find('.accordion-tabbed'));
                }
            });

            $(document).on(accordion.accVport[index] + '-off', function () {
                // Waiting for custom event that will be triggered by controller.js to activate responsive effects
                var target = accordion.$responsiveTarget[index];
                if (target.data('accordion-vport') === accordion.accVport[index]) {
                    target.removeClass('accordion-vport--res accordion-with-arrow');
                    target.find('.accordion-tabbed__content').show();
                }
            });
        },
    };
    if (config.enableAccordionTypeSubsection || config.enableAccordionTypeSingle) {
        accordion.on.toggle.single = function ($this) {
            let state;
            var $accordionContent = $this.next('.accordion__content');
            if (typeof $this.attr('data-content-target') !== 'undefined') {
                const contentTarget = $this.attr('data-content-target');
                $accordionContent = $(contentTarget);
            }
            $accordionContent.slideToggle(200, function () {
                if ($this.parent().hasClass('article-accordion')) {
                    $('.article-row-left').height('auto');
                    accordion.isStickyBody = state;
                }
            });
            $this.toggleClass('js--open');

            const $wrapper = $this.closest('.expandable-accordion');

            state = !($this.attr('aria-expanded') === 'true');
            $this.attr('aria-expanded', state);
            const accordionExpandedSingle = $.Event('accordion:expandedSingle');
            $(document).trigger(accordionExpandedSingle, [$this, $accordionContent]);
            if ($wrapper.length) accordion.on.checkExpandAll($this, state, $wrapper);
        };
    }
    if (config.enableAccordionExpandAll) {
        accordion.on.toggle.all = function ($this) {
            var $wrapper = $this.closest('.expandable-accordion');
            var state = !($this.attr('aria-expanded') === 'true');

            $this.attr('aria-expanded', state);
            if (state) {
                $wrapper.find('.accordion-tabbed__tab').addClass('js--open');
                $wrapper
                    .find('.accordion__control, .accordion-tabbed__control')
                    .addClass('js--open')
                    .attr('aria-expanded', state);
                $wrapper.find('.accordion__content, .accordion-tabbed__content').slideDown(200);

                $this.text('Hide All');

                const $lazy = $wrapper.find('[data-ajaxLoaded]');
                $lazy.each(function () {
                    if ($lazy.attr('[data-ajaxLoaded]') !== 'true' && $lazy.find('.accordion-lazy').length) {
                        accordion.getAccordionContent($lazy.find('.accordion-lazy'));
                    }
                });
            } else {
                $wrapper.find('.accordion-tabbed__tab').removeClass('js--open');
                $wrapper
                    .find('.accordion__control, .accordion-tabbed__control')
                    .removeClass('js--open')
                    .attr('aria-expanded', state);
                $wrapper.find('.accordion__content, .accordion-tabbed__content').slideUp(200);

                $this.text('Expand All');
            }
        };
    }
    accordion.validateAndSanitizeDoi = function (doi) {
        if (!doi || typeof doi !== 'string') {
            return null;
        }
        // Maximum length limit to prevent excessively long inputs (DOIs are typically < 200 chars)
        var MAX_DOI_LENGTH = 200;
        var trimmed = doi.trim();
        if (trimmed.length === 0 || trimmed.length > MAX_DOI_LENGTH) {
            return null;
        }
        // Reject any input that looks like a URL or contains protocol schemes (http://, https://, file://, etc.)
        var urlPattern = /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//;
        if (urlPattern.test(trimmed)) {
            return null;
        }
        // Reject any input containing suspicious patterns that could be used for SSRF
        var suspiciousPatterns = [
            /localhost/i,
            /127\.0\.0\.1/,
            /0\.0\.0\.0/,
            /::1/,
            /file:\/\//i,
            /ftp:\/\//i,
            /gopher:\/\//i,
            /ldap:\/\//i,
        ];
        for (var i = 0; i < suspiciousPatterns.length; i++) {
            if (suspiciousPatterns[i].test(trimmed)) {
                return null;
            }
        }
        // Sanitize: remove any characters that could be used for injection
        // Allow only alphanumeric, dots, slashes, hyphens, underscores (removed colon to prevent URL-like patterns)
        var sanitized = trimmed.replace(/[^a-zA-Z0-9.\/_-]/g, '');
        // Validate DOI format: should start with 10. followed by digits, then slash, then more characters
        // This is a strict validation - DOIs must follow pattern: 10.\d{4,}/.+
        var doiPattern = /^10\.\d{4,}\/[a-zA-Z0-9.\/_-]+$/;
        if (doiPattern.test(sanitized) && sanitized.length <= MAX_DOI_LENGTH) {
            return sanitized;
        }
        return null;
    };
    accordion.sendAnalyticsEvent = function (eventType, doi) {
        // Validate and sanitize DOI to prevent SSRF
        var validatedDoi = accordion.validateAndSanitizeDoi(doi);
        if (!validatedDoi) {
            console.warn('Invalid DOI format, skipping analytics event:', doi);
            return;
        }
        // Validate eventType to ensure it's one of the expected values
        var allowedEventTypes = ['showSummary', 'hideSummary'];
        if (!allowedEventTypes.includes(eventType)) {
            console.warn('Invalid event type, skipping analytics event:', eventType);
            return;
        }
        // Hardcoded URL to prevent SSRF
        const url = '/action/analytics';
        const params = new URLSearchParams();
        params.append('EventType', eventType);
        params.append('doi', validatedDoi);
        const urlWithParams = url + '?' + params.toString();

        fetch(urlWithParams, {
            method: 'GET',
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Failed to send analytics: ' + response.statusText);
                }
                console.log('Analytics event sent successfully:', {eventType: eventType, doi: validatedDoi});
            })
            .catch(function (error) {
                console.error('Error sending analytics event:', error);
            });
    };
    if (config.enableAccordionBehaviorOnlyOnSpecificViewPort) {
        accordion.preventAccordionBehavior = function ($this) {
            return !!$this.parents('[data-accordion-vport]:not(.accordion-vport--res)').length;
        };
    }
    if (!config.enableAccordionBehaviorOnlyOnSpecificViewPort) {
        accordion.preventAccordionBehavior = () => true;
    }
    UX.accordion = accordion; // add to global namespace
})();
